import React, { useEffect, useRef } from 'react'
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend } from 'chart.js';
import { Line as LineChart } from 'react-chartjs-2';
import { formatDateString } from '../helpers';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

const Line = ({ data, setValue }) => {
    const lineRef = useRef(null);
    const dates = data.map(item => item.date);
    const prices = data.map(item => item.price);

    const lineData = {
        labels: dates,
        datasets: [{
            data: prices,
            borderColor: '#404040',
            borderWidth: 2,
            backgroundColor: '#404040',
            pointRadius: 0,
            pointHoverRadius: 3,
            pointBorderWidth: 0,
            pointHoverBorderWidth: 0,
        }],
        
    };

    const lineOptions = {
        animation: false,
        interaction: {
            mode: 'index',
            intersect: false
        },
        scales: {
            x: {
                grid: {
                    display: false,
                    drawTicks: false,
                    drawBorder: false
                },
                ticks: {
                    display: false,
                }
            },
            y: {
                grace: '5%',
                grid: {
                    // display: false,
                    drawTicks: false,
                    drawBorder: false
                },
                ticks: {
                    display: false,
                }
            }
        },
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                enabled: false,
                external: (context) => {
                    let tooltipEl = document.getElementById('chartjs-line-tooltip');

                    // Create tooltip element if it doesn't exist
                    if (!tooltipEl) {
                        tooltipEl = document.createElement('div');
                        tooltipEl.id = 'chartjs-line-tooltip';
                        tooltipEl.style.position = 'absolute';
                        tooltipEl.style.pointerEvents = 'none';
                        tooltipEl.style.transform = 'translateX(-50%)';
                        document.body.appendChild(tooltipEl);
                    }

                    const tooltip = context.tooltip;
                    
                    // Hide tooltip when no tooltip data is available
                    if (!tooltip || tooltip.opacity === 0) {
                        tooltipEl.style.opacity = 0;
                        return;
                    }

                    // Set text content
                    tooltipEl.innerHTML = tooltip.dataPoints.map(dataPoint => `${formatDateString(dataPoint.label)}`)

                    requestAnimationFrame(() => {
                        const { caretX } = tooltip;
                        const toolTipHeight = tooltipEl.offsetHeight;
                        const chartRect = context.chart.canvas.getBoundingClientRect();

                        tooltipEl.style.left = `${chartRect.left + caretX + window.scrollX}px`;
                        tooltipEl.style.top = `${chartRect.top - toolTipHeight + window.scrollY}px`;
                        tooltipEl.style.opacity = 1;
                    })
                }
            }
        }
    };

    const verticalHoverLine = {
        id: 'verticalHoverLine',
        beforeDatasetDraw(chart) {
            const { ctx, chartArea: { top, bottom } } = chart;

            ctx.save();
            chart.getDatasetMeta(0).data.forEach((dataPoint) => {
                if(!dataPoint.active) return;

                ctx.beginPath();
                ctx.strokeStyle = '#bfbfbf';
                ctx.moveTo(dataPoint.x, top);
                ctx.lineTo(dataPoint.x, bottom);
                ctx.lineWidth = 1;
                ctx.stroke();
            });
        }
    }

    const tooltipHoverEffect = {
        id: 'tooltipHoverEffect',
        afterEvent(chart, { event }) {
            if(event.type === 'mousemove') {
                if(!event.chart.tooltip.dataPoints || event.chart.tooltip.dataPoints.length === 0) {
                    return;
                }

                setValue(event.chart.tooltip.dataPoints[0].raw);
                return;
            }

            return;
        }
    }

    useEffect(() => {
        const checkMousePosition = (event) => {
            if (lineRef.current) {
                const canvas = lineRef.current.canvas;
                const canvasRect = canvas.getBoundingClientRect();
                const mouseX = event.clientX;
                const mouseY = event.clientY;
            
                // if mouse is inside canvas
                if (
                    mouseX >= canvasRect.left && 
                    mouseX <= canvasRect.right && 
                    mouseY >= canvasRect.top &&
                    mouseY <= canvasRect.bottom
                ) return;
                
                const tooltip = document.getElementById('chartjs-line-tooltip');
                if(tooltip) {
                    tooltip.remove();
                }

                setValue(prices[prices.length - 1]);
                return;
            }
        }
        // Add global mousemove event listener
        window.addEventListener('mousemove', checkMousePosition);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('mousemove', checkMousePosition);
        };
    }, [data])

    return (
        <div>
            <LineChart ref={lineRef} data={lineData} options={lineOptions} plugins={[verticalHoverLine, tooltipHoverEffect]} />
        </div>
    )
}

export default Line;